import React, {useEffect} from "react"
import controller from "../../store/pageControllers/CategoryCompareController"
import {SkeletonBox} from "../../lib/wa-2.0"
import {observer} from "mobx-react-lite"
import ReactPaginate from "react-paginate"
import {CategoriesCompareTable} from "../../components/CategoryCompareTable"
import classNames from "classnames"
import {ReactComponent as Hierarhy} from "./hierarchy.svg";
import {ReactComponent as ListIcon} from "./list.svg";
import "./comparePage.sass"
import StepNavigation from "../../components/StepNavigation";
import {appPages} from "../../App";
import {useHistory} from "react-router"

export const CategoriesComparePage = observer(() => {

    const history = useHistory();

    useEffect(() => {
        controller.loadEntities()
    }, [])
    return <div>
        <h1>2. Сопоставление категорий</h1>
        <div className={"align-right custom-my-8"}>
            <button
                className={"button green ozon_save ozon_left"}
                onClick={()=>controller.saveAll()}
            >Сохранить</button>
            <ul className="paging hierarchy-select">
                <li
                    onClick={() => controller.hierarchy = false}
                    className={classNames({selected: !controller.hierarchy})}>
                    <Hierarhy viewBox={"0 0 21 15"} className={'hierarchy-icon'}/>
                </li>
                <li
                    onClick={() => controller.hierarchy = true}
                    className={classNames({selected: controller.hierarchy})}>
                    <ListIcon viewBox={"0 0 21 15"} className={'hierarchy-icon'}/>
                </li>
            </ul>
        </div>


        {controller.entitiesLoaded ? <div>
            <table>
                <thead style={{backgroundColor: "#F3F3F3"}}>
                <tr>
                    <th>Категория</th>
                    <th/>
                    <th>Категория в Ozon</th>
                </tr>
                </thead>
            </table>
            <CategoriesCompareTable categories={controller.entities}/>
        </div> : <SkeletonBox/>}

        {controller.countOfPages > 1 &&
        <div className={'paginate-compare'}>
            <ReactPaginate
                previousLabel={'Предыдущая'}
                nextLabel={'Следующая'}
                containerClassName={'paging'}
                pageCount={controller.countOfPages}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                initialPage={controller.page}
                onPageChange={({selected}) => {
                    controller.loadEntities(selected)
                }
                }
            />
        </div>}

        <StepNavigation next={undefined} back={appPages.selectProducts} save_next={()=>controller.saveAll().then(()=>history.push(appPages.generalOfferAttributes))}/>
    </div>
})